import {Badge} from '@mantine/core'

import {invoiceStatusColor} from 'src/theme/semantic-colors'

type InvoiceStatusBadgeProps = {
    isVoided: boolean
    isDraft: boolean
}

export function InvoiceStatusBadge({isVoided, isDraft}: InvoiceStatusBadgeProps) {
    if (isVoided) {
        return (
            <Badge color={invoiceStatusColor({isVoided: true, isDraft: false})} variant="light">
                Void
            </Badge>
        )
    }

    if (isDraft) {
        return (
            <Badge color={invoiceStatusColor({isVoided: false, isDraft: true})} variant="light">
                Draft
            </Badge>
        )
    }

    return (
        <Badge color={invoiceStatusColor({isVoided: false, isDraft: false})} variant="light">
            Invoiced
        </Badge>
    )
}
